import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Fade from "react-reveal/Fade";
import axios from "axios";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import * as Styles from "./Styles";
import Advantages from "../../assets/Images/LearnBarterImages/Advantages.webp";
import Barter_Trade from "../../assets/Images/LearnBarterImages/Barter_Trade.webp";
import Difference_between from "../../assets/Images/LearnBarterImages/Difference_between.webp";
import Ultimate_Guide from "../../assets/Images/LearnBarterImages/Ultimate_Guide.webp";
import arrowright from "../../assets/Images/LearnBarterImages/arrowright.svg";

const Blog = () => {
  const navigate = useNavigate();
  const [categoryData, setCategoryData] = useState([]);
  const getAllBlog = async () => {
    try {
      const response = await axios.get(`blog/Get_Blog`);
      setCategoryData(response.data);
    } catch (error) {}
  };

  const blogsData = [
    {
      id: 1,
      title: "Web Interface",
      description:
        "Advantages and disadvantages of the barter system of exchange",
      readMore:
        "/advantages-and-disadvantages-of-the-barter-system-of-exchange",
      imgurl: Advantages,
    },
    {
      id: 2,
      title: "Web Interface",
      description: " The Difference Between Barter Exchange and Money Exchange",
      readMore: "/difference-between-barter-exchange-and-money-exchange",
      imgurl: Difference_between,
    },
    {
      id: 3,
      title: "Web Interface",
      description:
        " The Ultimate Guide to Barter Exchange goods without involving money",
      readMore: "/barter-exchange-goods-without-involving-money",
      imgurl: Ultimate_Guide,
    },
    {
      id: 4,
      title: "Web Interface",
      description: " Barter trade Companies",
      readMore: "/barter-trade-companies",
      imgurl: Barter_Trade,
    },
  ];

  useEffect(() => {
    getAllBlog();
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
        Barter Exchange Blog: Insights on Trade Goods & B2B
        </title>
        <meta
          property="og:title"
          content=" Barter Exchange Blog: Insights on Trade Goods & B2B"
        />
        <meta
          name="og:description"
          content=" Explore the BXI blog for expert tips on how businesses can trade goods, make barter deals, and succeed in B2B marketplaces using barter coins in the system"
        />
        <meta
          name="description"
          content=" Explore the BXI blog for expert tips on how businesses can trade goods, make barter deals, and succeed in B2B marketplaces using barter coins in the system"
        />
         <meta
          name="keywords"
          content=" blog post, business blogs,blog page, Barter exchange, barter system, bxi, barter exchange, b2b, barter deals, barter, b2b marketplace, barter coins, trade goods"
        />
      </Helmet>
      <ToastContainer style={{ fontSize: "16px" }} />
      <Box>
        <Navbar />
      </Box>
      <Box sx={{ marginTop: "70px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          <Fade top duration={1000}>
            <Typography
              variant="inherit"
              component="span"
              sx={{ ...gradientText, lineHeight: "44px" }}
            >
              BLOGS
            </Typography>
          </Fade>
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: "15px" }}
        >
          <Typography sx={subNewsText}>
            Explore our Blogs to understand the meaning of Barter and gain
            valuable insights and tips on Barter.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            gap: "20px",
            flexWrap: "wrap",
            flexDirection: {
              xl: "row",
              lg: "row",
              md: "row",
              sm: "column",
              xs: "column",
            },
            mt: 5,
            width: "100%",
            maxWidth: "100vw",
            mx: "auto",
            overflow: "hidden",
            ml: 2,
            mr: 2,
          }}
        >
          {blogsData.map((item, index) => (
            <Box sx={Styles.newsblogBox}>
              <Box
                component={"img"}
                src={item?.imgurl}
                sx={{
                  height: "100%",
                  width: "100%",
                  maxHeight: "190px",
                  borderRadius: "18px",
                }}
              />
              <Typography sx={Styles.boxColorText2}>
                {item?.description}
              </Typography>
              <Box
                component={"a"}
                href={item?.readMore}
                target="_blank"
                alt="wtsp"
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "10px",
                  alignItems: "center",
                  mr: "auto",
                  cursor: "pointer",
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <Typography sx={Styles.boxColorText3}>Read More</Typography>
                <Box
                  component={"img"}
                  src={arrowright}
                  sx={{ height: "auto", maxWidth: "20px" }}
                />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default Blog;

const newsFeedTypoStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "17.6889px",
  lineHeight: "29px",
  alignItems: "center",
  textAlign: "center",
  textTransform: "capitalize",
  color: "rgba(73, 75, 122, 1)",
  marginTop: "20px",
  width: "317.99px",
  height: "58px",
};

const gradientText = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: {
    xs: "35px",
    sm: "35px",
    md: "35px",
    lg: "35px",
    xl: "35px",
  },
  textTransform: "uppercase",
  lineHeight: "65px",
  display: "flex",
  alignItems: "center",
  background:
    "linear-gradient(90deg, rgba(55, 93, 187, 1), rgba(7, 167, 247, 1))",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  textFillColor: "transparent",
};

const subNewsText = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: {
    xs: "15px",
    sm: "15px",
    md: "17px",
    lg: "18px",
    xl: "18px",
  },
  lineHeight: "14px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  color: "rgba(73, 75, 122, 1)",
};
